import Network from '@/services/network'
import { ref } from 'vue'

export default function handleAccounting() {
    const network = new Network;
    const accountingLoading = ref(false)

    const getBalanceSheet = (query) => {
      return network.api('get', '/accounting/balance-sheet'+ query);
    }

    const getCashFlowStatement = (query) => {
      return network.api('get', '/accounting/cash-flow-statement'+ query);
    }

    const getBalanceSheetColumnWise = (query) => {
      return network.api('get', '/accounting/fs-datasheet'+ query);
    }

    const getProfitLoss = (query) => {
      return network.api('get', '/accounting/profit-and-loss'+ query);
    }

    const getProfitLossAnalytics = (query) => {
      return network.api('get', '/accounting/profit-and-loss-analytics'+ query);
    }

    const getIncomeExpenditure = (query) => {
      return network.api('get', '/accounting/income-and-expenditure'+ query);
    }

    const getReceiptsPayments = (query) => {
        return network.api('get', '/accounting/receipts-payments'+ query);
    }

    const fetchChequeRegisterData = (query) => {
        return network.api('get', '/accounting/cheque-register'+ query);
    }
    const createChequeRegister = (data, query) => {
        return network.api('post', '/accounting/cheque-register' + query, data);
    }
    const updateChequeRegister = (data, chequeId, query) => {
        return network.api('put', '/accounting/cheque-register/'+ chequeId + query, data);
    }
    const fetchSingleChequeRegister = (chequeId, query) => {
        return network.api('get', '/accounting/cheque-register/' + chequeId + query);
    }
    const updateChequeRegisterStatus  = (data, chequeId, query) => {
        return network.api('put', `/accounting/cheque-register/${chequeId}/status` + query, data);
    }
    const fetchChequeRegisterSummary = (query) => {
        return network.api('get', '/accounting/cheque-register-summary' + query);
    }

    return {
        getBalanceSheet,
        getCashFlowStatement,
        getIncomeExpenditure,
        getBalanceSheetColumnWise,
        getProfitLoss,
        getProfitLossAnalytics,
        getReceiptsPayments,
        accountingLoading,
        fetchChequeRegisterData,
        createChequeRegister,
        updateChequeRegister,
        fetchSingleChequeRegister,
        updateChequeRegisterStatus,
        fetchChequeRegisterSummary
    }
}
